import React, { useState, useEffect, useCallback, useMemo } from "react";
import "./PropertiesMenu.css";
import Button from "@mui/material/Button";
import { useDropzone } from "react-dropzone";

import { ReactComponent as DeleteIcon } from "../../assets/delete.svg";

function CoachingPointDZ({
  type,
  chosenLanguage,
  prepareFile,
  fileReady,
  uploadFunc,
  uploading,
  existing,
  updateFileName,
  handleDelete,
}) {
  const [fileInfo, setFileInfo] = useState({});
  const [existingFile, setExistingFile] = useState(
    existing && existing.metadata
      ? { name: existing.metadata.name, size: existing.metadata.size }
      : null
  );

  useEffect(() => {
    setFileInfo(existingFile);
  }, []);

  useEffect(() => {
    updateFileName(null);
    prepareFile(null);
    setExistingFile(
      existing && existing.metadata
        ? { name: existing.metadata.name, size: existing.metadata.size }
        : null
    );
  }, [chosenLanguage]);

  const onDrop = useCallback((file) => {
    if (file.length) {
      const data = new FormData();
      data.append("file", file[0]);
      prepareFile(data);
      updateFileName({ name: String(file[0].path), size: file[0].size });
      setFileInfo({ name: file[0].path, size: file[0].size });
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: type === "audio" ? ".mp3" : ".vtt",
    maxFiles: 1,
  });

  const baseStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    padding: "10px",
    borderRadius: 2,
    height: "75px",
    margin: type === "audio" ? "0 0.5em 0 0" : "0 0 0 0.5em",
    borderColor: "#ddd",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };

  const activeStyle = {
    borderColor: "#8fddeb",
  };

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
    }),
    [isDragActive]
  );

  const convertSize = (fileSize) => {
    var sizes = ["Bytes", "KB", "MB"];
    var i = parseInt(Math.floor(Math.log(fileSize) / Math.log(1024)));
    return (fileSize / Math.pow(1024, i)).toFixed(2) + " " + sizes[i];
  };

  return (
    <div style={{ width: "50%" }}>
      <div className="dropzone-container" {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p>
          {`${
            type === "audio" ? "Audio file (" : "Subtitles file ("
          }${chosenLanguage})`}
          <br />
          {type === "audio" ? "(.mp3 only)" : "(.vtt only)"}
        </p>
      </div>
      {(fileReady || existingFile) && (
        <div className={`file-status ${type}`}>
          <div className="file-info-container">
            <div style={{ paddingLeft: "0.5em" }}>
              <p className="name">{fileInfo && fileInfo.name}</p>

              {fileInfo && fileInfo.size < 1024 && (
                <p className="size">{fileInfo.size} bytes</p>
              )}
              {fileInfo && fileInfo.size >= 1024 && (
                <p className="size">
                  {convertSize(fileInfo.size)} (
                  {Number(fileInfo.size).toLocaleString()} bytes)
                </p>
              )}
            </div>
            <button
              className={`delete-button ${
                uploading.audio || uploading.subtitles ? "disabled" : ""
              }`}
              disabled={uploading.audio || uploading.subtitles}
              onClick={() => {
                prepareFile(null); // set the file-to-upload to null
                updateFileName(null);
                setFileInfo(null);
                setExistingFile(null);
                handleDelete(type);
              }}
            >
              <DeleteIcon
                stroke={
                  uploading.audio || uploading.subtitles ? "#aeaeae" : "#f8ebea"
                }
                fill={
                  uploading.audio || uploading.subtitles ? "#aeaeae" : "#f8ebea"
                }
              />
            </button>
          </div>
          {!existing && (
            <div className="upload-button-container">
              <Button
                variant="contained"
                size="small"
                color="coachingPointAssetUploadButton"
                onClick={uploadFunc}
                disabled={uploading.audio || uploading.subtitles}
              >
                {uploading[type] ? "Uploading..." : "Upload"}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CoachingPointDZ;
